import React, { memo } from 'react'
import PropTypes from 'prop-types'
import IndeterminateCheckbox from '../../../IndeterminateCheckBox/IndeterminateCheckBox'

const CellCheckbox = ({ row, validateSelectable }) => {
  const onValidate = () => {
    if (validateSelectable) {
      return validateSelectable?.(row)
    }
    return true
  }
  return (
    <div>
      <IndeterminateCheckbox
        {...row.getToggleRowSelectedProps()}
        validateSelectable={onValidate}
      />
    </div>
  )
}

CellCheckbox.propTypes = {
  row: PropTypes.object,
  validateSelectable: PropTypes.func,
}

export default memo(CellCheckbox)
